import React from "react";

const AuthLoading = ({ message = "Processing..." }) => {
  return (
    <div className="page-loader" aria-live="polite" aria-busy="true" aria-label={message}>
      <i className="ti ti-loader-2" aria-hidden="true" />
    </div>
  );
};

export default AuthLoading;
